module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C156"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE ON FOOTNOTES")]), _vm._v(": For the reader’s ease in referencing frequently quoted titles, I have dispensed with the scholarly ciphers, more mystifying than helpful for the average fiction reader. These books will therefore be noted in the footnotes below as follows, rather than with the formal notations of op. cit., loc. cit., ibid., etc.")]), _vm._v(" "), _c('p', {
    staticClass: "C151"
  }, [_c('span', {
    staticClass: "Underline"
  }, [_vm._v("Bulloch, Bibliography—“")]), _vm._v("A Bibliography of George MacDonald,” by John Malcolm Bulloch, "), _c('em', [_vm._v("The Aberdeen University Library Bulletin")]), _vm._v(", February, 1925, Vol. V, No. 30.")]), _vm._v(" "), _c('p', {
    staticClass: "C151"
  }, [_c('span', {
    staticClass: "Underline"
  }, [_vm._v("Greville, "), _c('em', [_vm._v("Biography")])]), _vm._v("—"), _c('em', [_vm._v("George MacDonald and His Wife")]), _vm._v(" by Greville MacDonald, George Allen & Unwin, London, 1924.")]), _vm._v(" "), _c('p', {
    staticClass: "C151"
  }, [_c('span', {
    staticClass: "Underline"
  }, [_vm._v("Hein, "), _c('em', [_vm._v("Mythmaker")])]), _vm._v("—"), _c('em', [_vm._v("George MacDonald, Victorian Mythmaker")]), _vm._v(" by Rolland Hein, Star Song Publishing, Nashville, TN, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "C151"
  }, [_c('span', {
    staticClass: "Underline"
  }, [_vm._v("Sadler, "), _c('em', [_vm._v("Letters")])]), _vm._v("—"), _c('em', [_vm._v("An Expression of Character: The Letters of George MacDonald")]), _vm._v(" Edited by Glenn Edward Sadler, William B. Eerdmans, Grand Rapids, MI, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "C151"
  }, [_c('span', {
    staticClass: "Underline"
  }, [_vm._v("Shaberman, "), _c('em', [_vm._v("Study")])]), _vm._v("— "), _c('em', [_vm._v("George MacDonald, A Bibliographical Study")]), _vm._v(" by Raphael B. Shaberman, St. Paul’s Bibliographies, Winchester, Hampshire, U.K., 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "C151",
    staticStyle: {
      "margin-bottom": "20%"
    }
  }, [_c('span', {
    staticClass: "Underline"
  }, [_vm._v("Srebrnik, "), _c('em', [_vm._v("Strahan")])]), _vm._v("— "), _c('em', [_vm._v("Alexander Strahan: Victorian Publisher")]), _vm._v(", by Patricia Thomas Srebrnik, University of Michigan Press, Ann Arbor, 1986.")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "display": "block"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "C112"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#id_23",
      "id": "id_24"
    }
  }, [_vm._v("1")]), _vm._v(" Greville, "), _c('em', [_vm._v("Biography")]), _vm._v(", p. 353.")]), _vm._v(" "), _c('p', {
    staticClass: "C112"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#id_25",
      "id": "id_26"
    }
  }, [_vm._v("2")]), _vm._v(" Lee and Shepard was but one of Boston’s several publishers with a keen interest in MacDonald’s books—others included Lothrop, Hoyt, and Roberts Brothers. To complete the fascinating story, Lee and Shepherd merged with Lothrop in 1905.")]), _vm._v(" "), _c('p', {
    staticClass: "C112"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#id_27",
      "id": "id_28"
    }
  }, [_vm._v("3")]), _vm._v(" GMD to Mrs. George Cupples, Feb. 12, 1872, Sadler, "), _c('em', [_vm._v("Letters")]), _vm._v(", pp. 187-88.")]), _vm._v(" "), _c('p', {
    staticClass: "C112"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#id_29",
      "id": "id_30"
    }
  }, [_vm._v("4")]), _vm._v(" Shaberman, "), _c('em', [_vm._v("Study")]), _vm._v(", p. 51.")]), _vm._v(" "), _c('p', {
    staticClass: "C112"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#id_31",
      "id": "id_32"
    }
  }, [_vm._v("5")]), _vm._v(" Bulloch, "), _c('em', [_vm._v("Bibliography")]), _vm._v(", p. 724.")]), _vm._v(" "), _c('p', {
    staticClass: "C112"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#id_33",
      "id": "id_34"
    }
  }, [_vm._v("6")]), _vm._v(" GMD to Louisa, April 13, 1868, quoted in Hein, "), _c('em', [_vm._v("Mythmaker")]), _vm._v(", p. 210.")]), _vm._v(" "), _c('p', {
    staticClass: "C112"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#id_21",
      "id": "id_22"
    }
  }, [_vm._v("7")]), _vm._v(" Srebrnik, "), _c('em', [_vm._v("Strahan")]), _vm._v(", p. 5.")]), _vm._v(" "), _c('p', {
    staticClass: "C112"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#id_19",
      "id": "id_20"
    }
  }, [_vm._v("8")]), _vm._v(" In their bibliographies, both Bulloch (Bulloch, "), _c('em', [_vm._v("Bibliography")]), _vm._v(") and Shaberman (Shaberman, "), _c('em', [_vm._v("Study")]), _vm._v(", p. 52) list this Roberts edition as published in 1871. This is interesting in that on May 20 of 1872 (the "), _c('em', [_vm._v("following")]), _vm._v(" year), MacDonald wrote to Louisa about working on the proofs for the book. He wrote, “I must try to work on my proofs in the train, or I don’t know how I shall get through with the last of the "), _c('em', [_vm._v("Vicar")]), _vm._v(" which is now being lugged from me.” (Greville, "), _c('em', [_vm._v("Biography")]), _vm._v(", p. 418) And four days later: “You won’t mind a short note, dearest—for I have been busy with the Vicar’s Daughter all day, & now I must see to my lecture this evening for I am far from ready.” (quoted in "), _c('em', [_vm._v("Wingfold")]), _vm._v(", #99, Summer 2017) Clearly he is speaking of the upcoming British edition. From this, as well as that the serialization of "), _c('em', [_vm._v("The Vicar’s Daughter")]), _vm._v(" in "), _c('em', [_vm._v("The Sunday Magazine")]), _vm._v(" supposedly ran into 1872, it is clear that the 1871 date is in error. If Roberts indeed pirated their edition from the magazine, the date would still be 1872, as the title page of my Roberts edition confirms.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e24020a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0008.vue
// module id = 84
// module chunks = 0